var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4996 11.4C16.0026 11.4 15.5996 11.8029 15.5996 12.3C15.5996 12.797 16.0026 13.2 16.4996 13.2H19.4996C19.9967 13.2 20.3996 12.797 20.3996 12.3C20.3996 11.8029 19.9967 11.4 19.4996 11.4H16.4996ZM2.75 0C1.23122 0 0 1.23122 0 2.75V14.25C0 15.7688 1.23122 17 2.75 17H21.25C22.7688 17 24 15.7688 24 14.25V2.75C24 1.23122 22.7688 0 21.25 0H2.75ZM1.5 14.25V6.5H22.5V14.25C22.5 14.9404 21.9404 15.5 21.25 15.5H2.75C2.05964 15.5 1.5 14.9404 1.5 14.25ZM1.5 5V2.75C1.5 2.05964 2.05964 1.5 2.75 1.5H21.25C21.9404 1.5 22.5 2.05964 22.5 2.75V5H1.5Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCardIcon);
export default __webpack_public_path__ + "static/media/payment-card-icon.cf23a41e985f82bacf11aef79daf1db2.svg";
export { ForwardRef as ReactComponent };